export default "__VITE_ASSET__DWvXsFYP__"